<template>
  <v-container grid-list-lg>
    <v-layout flex align-center justify-center row wrap>
      <v-flex xs12>
        <v-toolbar height="56" color="primary">
          <v-toolbar-title id="idCabecalhoJanela" class="subheading white--text">
            {{ modoEdicao ? 'Edição de Usuário': 'Cadastro de Usuário' }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card>
          <v-card-text>
            <v-container grid-list-lg>
              <v-form ref="formCadastroUsuario" v-model="formValidCadastroUsuario">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs12 md4>
                        <v-text-field id="idNomeUsuario" ref="idNomeUsuarioRef"
                          label="Nome*"
                          v-model="usuarioModel.nome"
                          :rules="formRulesComputed.usuario.nome(usuarioModel.nome)"
                        ></v-text-field>
                      </v-flex>
                      <v-spacer></v-spacer>
                      <v-flex xs12 md4>
                        <v-text-field id="idEmailUsuario" ref="idEmailUsuarioRef"
                          label="E-mail*"
                          v-model="usuarioModel.email"
                          :rules="formRulesComputed.usuario.email(usuarioModel.email, emailEmUso)"
                          @change="validaEmail()"
                          validate-on-blur>
                        </v-text-field>
                      </v-flex>
                      <v-spacer></v-spacer>
                      <v-flex xs12 sm3>
                        <v-select id="idPerfilUsuario" ref="perfilUsuarioRef"
                          label="Perfil*"
                          v-model="usuarioModel.perfil"
                          :items="perfilComputed.perfilList(modoEdicao && edicaoUsuarioCliente)"
                          :rules="formRulesComputed.usuario.perfil(usuarioModel.perfil)"
                          :disabled="edicaoUsuarioCliente"
                          item-text="descricao"
                          item-value="id"
                          return-object
                          required>
                        </v-select>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs4 sm1>
                        <v-text-field id="idDddUsuario" ref="idDddUsuarioRef"
                          :label="edicaoUsuarioCliente ? 'DDD*' : 'DDD'"
                          v-model="usuarioModel.telefones[0].ddd"
                          :rules="formRulesComputed.telefone.ddd(usuarioModel.telefones[0].ddd, edicaoUsuarioCliente || telefoneOuDddDigitados)"
                          maxlength="2"
                          mask="##">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs8 sm3>
                        <v-text-field id="idTelefoneUsuario" ref="idTelefoneUsuarioRef"
                          :label="edicaoUsuarioCliente ? 'Telefone*' : 'Telefone'"
                          v-model="usuarioModel.telefones[0].telefone"
                          :rules="formRulesComputed.telefone.numero(usuarioModel.telefones[0].telefone, edicaoUsuarioCliente || telefoneOuDddDigitados)">
                        </v-text-field>
                      </v-flex>
                      <v-spacer></v-spacer>
                      <v-flex xs12 sm4>
                        <v-select id="idGrupoUsuario" ref="grupoUsuarioRef"
                          label="Grupo de Usuário"
                          v-model="usuarioModel.grupos[0]"
                          :items="grupoList"
                          :disabled="edicaoUsuarioCliente"
                          item-text="nome"
                          item-value="id"
                          return-object
                          required>
                        </v-select>
                      </v-flex>
                      <v-spacer></v-spacer>
                      <v-flex xs12 sm3>
                        <v-select id="idStatusUsuario" ref="idStatusUsuarioRef"
                          label="Status*"
                          :items="statusList"
                          item-text="descricao"
                          item-value="ativo"
                          :rules="formRulesComputed.usuario.status(usuarioModel.ativo)"
                          v-model="usuarioModel.ativo"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-checkbox
                          v-model="usuarioModel.gestaoTaxasSeguro"
                          color="primary"
                          label="Gestão de Taxas de Seguro"
                        ></v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs12 sm4 text-xs-right
                      v-if="listPerfisConfiguraveisVisualizaSolicitacaoTipoSolicitacao.includes(usuarioModel.perfil.id)">
                        <v-select id="idAutorizaVisualizacaoAnalista" ref="autorizaVisualizacaoAnalistaRef"
                          label="Tipo das solicitações visualizadas*"
                          :items="hc_tipoSolicitacao.tipoSolicitacaoList()"
                          item-text="descricao"
                          :rules="formRulesComputed.usuario.restricaoAcesso(tipoSolicitacaoRestricao)"
                          :disabled="campoTipoSolicitacaoDisabled"
                          v-model="tipoSolicitacaoRestricao"
                          return-object
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm4 text-xs-right
                      v-if="perfilPermiteCalculoRandon">
                        <v-select id="idFazCalculoRandon" ref="fazCalculoRandonRef"
                          label="Faz Cálculo para Randon"
                          :items="simNaoList"
                          item-text="descricao"
                          item-value="valor"
                          v-model="usuarioModel.fazCalculoRandon"
                        ></v-select>
                      </v-flex>
                      <v-spacer></v-spacer>
                      <v-flex xs12 sm3 v-if="$route.params.id" text-xs-right>
                        <v-btn id="idRecuperacaoSenhaBtn" ref="recuperacaoSenhaBtnRef"
                          color="secondary"
                          class="white--text"
                          :block="$vuetify.breakpoint.xsOnly"
                          @click="resetSenha()">Resetar senha</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 mt-4>
        <v-btn text-md-left text-xs-center
          id="idVoltarCadastroUsuarioBtn"
          ref="voltarCadastroUsuarioBtnRef"
          :block="$vuetify.breakpoint.xsOnly"
          class="white--text left"
          color="primary"
          flat
          @click.native="voltar()">
            Voltar
        </v-btn>
        <v-btn text-md-right text-xs-center :disabled="!formValidCadastroUsuario || loadingSalvar"
          id="idSalvarUsuarioBtn"
          ref="salvarUsuarioBtnRef"
          :block="$vuetify.breakpoint.xsOnly"
          :loading="loadingSalvar"
          class="white--text right"
          color="primary"
          @click.native="salvarUsuario()">
            Salvar
          <v-icon right class="hidden-sm-and-down">save</v-icon>
        </v-btn>
      </v-flex>
      <v-snackbar
        :timeout="6000"
        :color="snackbar.sucesso ? 'success' : 'error'"
        multi-line
        v-model="snackbar.visivel">
          {{ snackbar.mensagem }}
          <v-btn id="idFecharSnackbarBtn" dark flat @click.native="snackbar.visivel = false">Fechar</v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import formRules from '@/helpers/form-rules';
import perfil from '@/helpers/perfil';
import usuarioHelper from '@/helpers/usuario-logado';
import permissoes from '@/helpers/permissoes.js';
import h_tipoSolicitacao from '@/helpers/tipo-solicitacao.js';
import auditoria from '@/helpers/auditoria';

export default {
  name: 'CadastroUsuario',
  data: () => {
    return {
      loadingSalvar: false,
      formValidCadastroUsuario: false,
      emailEmUso: false,
      listPerfisConfiguraveisVisualizaSolicitacaoTipoSolicitacao: [],
      grupoList: null,
      tipoSolicitacaoRestricao: null,
      usuarioEmEdicao: null,
      usuarioModel: {
        nome: '',
        email: '',
        ativo: true,
        gestaoTaxasSeguro: false,
        perfil: {
          id: '',
          descricao: ''
        },
        telefones: [
          {
            ddd: '',
            telefone: ''
          }
        ],
        grupos: [],
        fazCalculoRandon: false
      },
      statusList: [
        {
          descricao: 'Ativo',
          ativo: true
        },
        {
          descricao: 'Inativo',
          ativo: false
        },
      ],
      simNaoList: [
        {
          descricao: 'Sim',
          valor: true
        },
        {
          descricao: 'Não',
          valor: false
        },
      ],
      snackbar: {
        visivel: false,
        sucesso: false,
        mensagem: ''
      }
    }
  },
  computed: {
    formRulesComputed: function() {
      return formRules;
    },
    perfilComputed: function() {
      return perfil;
    },
    modoEdicao: function() {
      return this.$route.params.id;
    },
    edicaoUsuarioCliente: function() {
      const self = this;
      if (self.modoEdicao && self.usuarioEmEdicao) {
        return self.usuarioEmEdicao.perfil.id == perfil.CLIENTE ? true : false;
      } else {
        return false;
      }
    },
    campoTipoSolicitacaoDisabled: function() {
      const self = this;
      if (self.usuarioModel) {
        if (self.usuarioModel.perfil) {
          return self.usuarioModel.perfil.id == self.perfilComputed.PLATAFORMA;
        }
        return false;
      } else {
        return false;
      }
    },
    perfilPermiteCalculoRandon: function() {
      const idPerfil = this.usuarioModel.perfil ? this.usuarioModel.perfil.id : null;
      return idPerfil == perfil.ANALISTA || idPerfil == perfil.ADMINISTRADOR;
    },
    telefoneOuDddDigitados: function() {
      return this.usuarioModel.telefones[0].ddd != '' || this.usuarioModel.telefones[0].telefone != '';
    },
    hc_tipoSolicitacao: function() {
      return h_tipoSolicitacao;
    }
  },
  watch: {
    "usuarioModel.perfil": function(newValue, oldValue) {
      if (newValue.id == perfil.PLATAFORMA) {
        this.tipoSolicitacaoRestricao = h_tipoSolicitacao.getTipoSolicitacaoPorId(h_tipoSolicitacao.PLATAFORMA);
      } else if (newValue.id != oldValue.id) {
        this.tipoSolicitacaoRestricao = h_tipoSolicitacao.getTipoSolicitacaoPorId(h_tipoSolicitacao.TODOS);
      }

      if (newValue.id != perfil.ANALISTA && newValue.id != perfil.ADMINISTRADOR) {
        this.usuarioModel.fazCalculoRandon = false;
      }
    }
  },
  mounted: async function() {
    await this.carregaGrupos();
    await this.carregaPerfisConfiguraveisVisualizaSolicitacaoTipoSolicitacao();
    this.tipoSolicitacaoRestricao = h_tipoSolicitacao.tipoSolicitacaoList()[0];

    if (this.modoEdicao) {
      await this.buscaUsuario();
    }
  },
  methods: {
    getPermissao: function(requested) {
      const permissionObj = permissoes;
      return eval('permissionObj.verificaPermissao(permissionObj.SolicitacaoConsulta.' + requested + ')');
    },
    carregaGrupos: async function() {
      const self = this;
      self.$store.commit('startLoading');
      await axios.get(`${process.env.URL_GRUPOMS}/v1/buscaGruposModelSimples`, {
            headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` } })
      .then((response) => {
        self.grupoList = response.data;/*.filter((grupo) => {
          return grupo.ativo == true;
        });*/
        self.grupoList.unshift({ id: -1, nome: 'Nenhum', ativo: false });
        self.$store.commit('endLoading');
      });
    },
    carregaPerfisConfiguraveisVisualizaSolicitacaoTipoSolicitacao: async function() {
      const self = this;
      await axios.get(`${process.env.URL_USUARIOMS}/v1/buscaPerfisAutorizadosParaPermissao?idPermissao=9`, {
            headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` } })
      .then((response) => {
        self.listPerfisConfiguraveisVisualizaSolicitacaoTipoSolicitacao = response.data;
      });
    },
    buscaUsuario: async function() {
      const self = this;
      self.$store.commit('startLoading');
      await axios.get(`${process.env.URL_USUARIOMS}/v1/buscaUsuarioSimplesPorId?id=${this.$route.params.id}`, {
        headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }})
      .then((response) => {
        self.usuarioModel = response.data;
        if (!self.usuarioModel.telefones || !self.usuarioModel.telefones.length) {
          self.usuarioModel.telefones = [ { ddd: '', telefone: '' } ];
        }
        self.usuarioModel.telefones[0].ddd = self.usuarioModel.telefones[0].ddd != 0 ? `${self.usuarioModel.telefones[0].ddd}` : '';
        self.usuarioEmEdicao = JSON.parse(JSON.stringify(self.usuarioModel));
        //self.$store.commit('endLoading');
        self.carregarTipoSolicitacaoRestricao();
      })
      .catch((erro) => {
        self.$store.commit('endLoading');
        self.snackbar.mensagem = 'Não foi possível carregar as informações de usuário.';
        self.snackbar.sucesso = false;
        self.snackbar.visivel = true;
      });
    },
    carregarTipoSolicitacaoRestricao: async function() {
      const self = this;
      self.$store.commit('startLoading');
      await axios.get(`${process.env.URL_QUESTIONARIOMS}/v1/tipo-solicitacao/restricoes?idUsuario=${this.$route.params.id}`, {
        headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }
      })
      .then((response) => {
        if (response.data) {
          self.tipoSolicitacaoRestricao = h_tipoSolicitacao.getTipoSolicitacaoPorId(response.data.idTipoSolicitacao);
        } else {
          self.tipoSolicitacaoRestricao = h_tipoSolicitacao.tipoSolicitacaoList()[0];
        }
        self.$store.commit('endLoading');
      })
      .catch((erro) => {
        self.snackbar.mensagem = 'Não foi possível carregar as informações de usuário.';
        self.snackbar.sucesso = false;
        self.snackbar.visivel = true;
      });
    },
    salvarUsuario: function() {
      const self = this;
      self.$store.commit('startLoading');
      self.loadingSalvar = true;

      if (self.usuarioModel.grupos.length > 0) {
        if (self.usuarioModel.grupos[0].id == -1) {
          self.usuarioModel.grupos = [];
        }
      }

      axios.post(`${process.env.URL_USUARIOMS}/v1/insereOuAtualizaClienteTelaCadastro`, self.usuarioModel, {
            headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` } })
      .then((response) => {
        if (!self.usuarioEmEdicao) {
          self.enviaEmailCadastroSenha(response.data.id);
        }
        auditoria.registrar(self.montaStringDescricaoAuditoria(), '', '' );
        self.resetUsuarioModel();
        self.loadingSalvar = false;
        self.$store.commit('endLoading');
        self.salvarTipoSolicitacaoRestricao(response.data.id);
        //self.go('GestaoUsuarios', {snackbarText: this.modoEdicao ? 'Usuário editado com sucesso' : 'Sucesso! E-mail para cadastro de senha enviado ao usuário', snackbarMostrar: true, snackbarSucesso: true});
      })
      .catch((erro) => {
        console.log(erro)
        self.$store.commit('endLoading');
        self.loadingSalvar = false;
        self.snackbar.mensagem = 'Não foi possível completar a operação.';
        self.snackbar.sucesso = false;
        self.snackbar.visivel = true;
      })
    },
    salvarTipoSolicitacaoRestricao: async function(idUsuario) {
      const self = this;
      self.$store.commit('startLoading');
      await axios.post(`${process.env.URL_QUESTIONARIOMS}/v1/tipo-solicitacao/restricoes?idUsuario=${idUsuario}`, self.tipoSolicitacaoRestricao, {
            headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` } })
      .then((response) => {
        self.$store.commit('endLoading');
        self.go('GestaoUsuarios', {snackbarText: this.modoEdicao ? 'Usuário editado com sucesso' : 'Sucesso! E-mail para cadastro de senha enviado ao usuário', snackbarMostrar: true, snackbarSucesso: true});
      })
      self.$store.commit('endLoading');
    },
    montaStringDescricaoAuditoria: function() {
      const self = this;
      if (!self.usuarioEmEdicao) {
        return `Cadastrado usuário: ${self.usuarioModel.nome}`;
      } else {
        let mensagem = `Alterado cadastro do usuário: ${self.usuarioModel.nome}. `;

        if(self.usuarioModel.email != self.usuarioEmEdicao.email) {
          mensagem += `Email: ${self.usuarioModel.email}. `
        }
        if(self.usuarioModel.perfil.descricao != self.usuarioEmEdicao.perfil.descricao) {
          mensagem += `Perfil: ${self.usuarioModel.perfil.descricao}. `
        }
        if(self.usuarioModel.ativo != self.usuarioEmEdicao.ativo) {
          mensagem += `Status: ${self.usuarioModel.ativo? 'Ativo':'Inativo'}. `
        }
        if(self.usuarioModel.gestaoTaxasSeguro != self.usuarioEmEdicao.gestaoTaxasSeguro) {
          mensagem += `Gestão de Taxas de Seguro: ${self.usuarioModel.gestaoTaxasSeguro? 'Sim':'Não'}. `
        }
        if(self.usuarioModel.fazCalculoRandon != self.usuarioEmEdicao.fazCalculoRandon) {
          mensagem += `Faz Cálculo para Randon: ${self.usuarioModel.fazCalculoRandon? 'Sim':'Não'}. `
        }
        if((self.usuarioModel.telefones[0].ddd != self.usuarioEmEdicao.telefones[0].ddd)
          || (self.usuarioModel.telefones[0].telefone != self.usuarioEmEdicao.telefones[0].telefone)) {
          mensagem += `Telefone: (${self.usuarioModel.telefones[0].ddd ? self.usuarioModel.telefones[0].ddd : ''})
                               ${self.usuarioModel.telefones[0].telefone ? self.usuarioModel.telefones[0].telefone : ''}`
        }
        if(self.usuarioModel.grupos.length == 0 && self.usuarioEmEdicao.grupos.length > 0) {
          mensagem += ` Removido do Grupo: ${self.usuarioEmEdicao.grupos[0].nome}`
        } else if (!(self.usuarioModel.grupos.length == 0 && self.usuarioEmEdicao.grupos.length == 0)) {

          if((self.usuarioModel.grupos.length != self.usuarioEmEdicao.grupos.length
            || self.usuarioModel.grupos[0].id != self.usuarioEmEdicao.grupos[0].id)){
              mensagem += ` Grupo: ${self.usuarioModel.grupos[0].nome}`
        }

        }

        return mensagem;
      }
    },
    validaEmail: function() {
      const self = this;
      self.$store.commit('startLoading');
      axios.get(`${process.env.URL_USUARIOMS}/v1/no-auth/verificaEmailCadastrado?email=${self.usuarioModel.email}`)
      .then((response) => {
        self.emailEmUso = response.data;
        if (self.usuarioEmEdicao) {
          if (self.emailEmUso == true && self.usuarioEmEdicao.email == self.usuarioModel.email) {
            self.emailEmUso = false;
          }
        }
        self.$store.commit('endLoading');
      })
      .catch((erro) => {
        self.$store.commit('endLoading');
        self.snackbar.visivel = true;
        self.snackbar.sucesso = false;
        self.snackbar.mensagem = 'Ocorreu um erro ao validar o e-mail';
      });
    },
    resetUsuarioModel: function() {
      this.usuarioModel = { nome: '', email: '', ativo: true, gestaoTaxasSeguro: false, perfil: { id: '', descricao: '' },
                          telefones: [ { ddd: '', telefone: '' } ], grupos: [], fazCalculoRandon: false };
    },
    enviaEmailCadastroSenha: function(idUsuario) {
      const self = this;
      if (!self.usuarioEmEdicao) {
        axios.post(`${process.env.URL_USUARIOMS}/v1/no-auth/cadastraSenha?id=${idUsuario}`)
        .catch((err) => {
            self.snackbar.visivel = true;
            self.snackbar.sucesso = false;
            self.snackbar.mensagem = 'Erro ao enviar e-mail de cadastro de senha.';
            self.loadingEnviar = false;
        });
      }
    },
    resetSenha: function() {
      const self = this;
      self.$store.commit('startLoading');
      if (self.usuarioEmEdicao) {
        axios.post(`${process.env.URL_USUARIOMS}/v1/no-auth/resetaSenha?email=${self.usuarioEmEdicao.email}`)
        .then((response) => {
          auditoria.registrar(`Reset na senha do usuário: ${self.usuarioModel.nome}`, '', '' )
          self.$store.commit('endLoading');
          self.snackbar.visivel = true;
          self.snackbar.sucesso = true;
          self.snackbar.mensagem = 'As instruções foram enviadas para o e-mail do usuário.';
          self.loadingEnviar = false;
        })
        .catch((err) => {
          self.$store.commit('endLoading');
          self.snackbar.visivel = true;
          self.snackbar.sucesso = false;
          self.snackbar.mensagem = 'Erro ao enviar e-mail de recuperação.';
          self.loadingEnviar = false;
        });
      }
    },
    voltar: function() {
      this.$router.push('/GestaoUsuarios')
    },
    go: function(routeName, routeParams) {
      const self = this;
      if (!routeParams) {
        self.$router.push({name: routeName});
      } else {
        self.$router.push({name: routeName, params: routeParams});
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/usuarios/CadastroUsuario.vue